import CustomizableSection from 'pages/MasterCampaignPlanPage/new/components/ExecutiveSummary/CustomizableSection'
import React, { FC } from 'react'

import { EuiTitle, EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiText, EuiButtonIcon } from '@elastic/eui'

import { MasterCampaignPlan, MasterCampaignPlanCustomSection } from 'api/entities/MasterCampaignPlan'

export interface AudienceAndGeoTargetingProps {
  masterCampaignPlan: MasterCampaignPlan
  audienceSection: MasterCampaignPlanCustomSection | null | undefined
  geoSection: MasterCampaignPlanCustomSection | null | undefined
}

const AudienceAndGeoTargeting: FC<AudienceAndGeoTargetingProps> = ({ masterCampaignPlan, audienceSection, geoSection }) => {
  const audienceHidden = audienceSection?.hideAll === true
  const geoHidden = geoSection?.hideAll === true

  const bothVisible = !audienceHidden && !geoHidden

  return (
    <EuiFlexGroup direction='row' gutterSize='xl' alignItems='flexStart' wrap>
      {!audienceHidden && (
        <EuiFlexItem style={{ flexBasis: bothVisible ? '500px' : '100%', minHeight: '0' }}>
          <CustomizableSection section={audienceSection} defaultTitle='Audience Strategy' defaultContent={masterCampaignPlan.audienceSummary} defaultShowTitle={true} separator='horizontalRule' />
        </EuiFlexItem>
      )}
      {!geoHidden && (
        <EuiFlexItem style={{ flexBasis: bothVisible ? '500px' : '100%', minHeight: '0' }}>
          <CustomizableSection section={geoSection} defaultTitle='Geographic Targeting' defaultContent={masterCampaignPlan.geoSummary} defaultShowTitle={true} separator='horizontalRule' />
        </EuiFlexItem>
      )}
    </EuiFlexGroup>
  )
}

export default AudienceAndGeoTargeting
